import Svg from 'components/UI/SVG'
import { Dispatch, SetStateAction } from 'react'
import { Flex, get, Text } from 'theme-ui'
import { AvailablePlatforms } from 'utils/downloadPageUtils'
import { platforms } from 'utils/platformList'

export default function PlatformSelector({
  platformName,
  setPlatform,
  availablePlatforms,
}: {
  platformName: AvailablePlatforms
  setPlatform: Dispatch<SetStateAction<AvailablePlatforms>>
  availablePlatforms: AvailablePlatforms[]
}): JSX.Element {
  const currentPlatform = platforms[platformName]
  return (
    <Flex sx={{ flexDirection: 'column' }}>
      <Flex
        sx={{
          gap: '4rem',
          alignItems: 'center',
          justifyContent: 'center',
        }}
      >
        {Object.values(availablePlatforms).map(platform => (
          <Flex
            key={platforms[platform].name}
            sx={{
              position: 'relative',
              alignItems: 'flex-start',
              justifyContent: 'center',
              'span, svg path': {
                transition: theme => `${get(theme, 'transitions.default')}`,
              },
              ':hover': {
                cursor: 'pointer',
                '& span': {
                  color: 'white',
                },
                '& svg path': {
                  fill: 'white',
                },
              },
              gap: '1.6rem',
              minHeight: '4.2rem',
            }}
            onClick={() => {
              setPlatform(platform as AvailablePlatforms)
            }}
            data-testid={`${platform}-platform-option`}
          >
            <Flex sx={{ gap: '1.6rem', alignItems: 'center' }}>
              <Svg
                svg={platforms[platform].icon}
                sx={{
                  width: '2.4rem',
                  height: '2.4rem',
                  '& path': {
                    fill: currentPlatform.name === platform ? 'white' : 'white50',
                  },
                }}
              />
              <Text
                sx={{
                  color: currentPlatform.name === platform ? 'white' : 'white50',
                  fontWeight: 'bold',
                  display: ['none', 'block', 'block'],
                }}
              >
                {platform}
              </Text>
            </Flex>
            {platforms[platformName].name === platform && (
              <div
                sx={{
                  position: 'absolute',
                  width: '100%',
                  height: '0.2rem',
                  backgroundColor: 'white',
                  bottom: '-0.2rem',
                  right: 0,
                }}
              />
            )}
          </Flex>
        ))}
      </Flex>
      <Flex>
        <div
          sx={{
            width: ['100%', '72rem', 'maxContentWidth'],
            height: '0.2rem',
            background: ({ colors }) =>
              `linear-gradient(to left, ${colors?.transparent}, ${colors?.white10} 50%, ${colors?.transparent})`,
          }}
        />
      </Flex>
    </Flex>
  )
}
